import { Button } from "primereact/button";
import { useForm } from 'react-hook-form';
import { JVInput } from "../../../shared/JVInput";
import { JVDropdownInput } from "../../../shared/JVDropdownInput";
import { Fetch } from "../../../shared/Fetch";
import { IClientCompanyDropdown } from "../../../models/IDropdown";
import { useState } from "react";
import { JVDate } from "../../../shared/JVDate";

export interface IRecRepFilter {
    fromDate?: Date | null,
    toDate?: Date | null,
    subVendorID?: number | null,
    subVendor?: IClientCompanyDropdown,
    subvendor_Name?: string | null,
}

export const EmptyRecRepFilter: IRecRepFilter = {
    subvendor_Name: "",
    subVendorID: null,
    subVendor: { vendor_Company_ID: 0, vendor_Company_Name: "" },
}

interface Iprops {
    salEffFilter: IRecRepFilter,
    setSalEffFilter: (salEffFilter: IRecRepFilter) => void,
    onsearch:()=> void,
}

export const Filter = (props: Iprops) => {
    const [subVendorCompanies, setsubVendorCompanies] = useState<Array<IClientCompanyDropdown>>();

    const { control, handleSubmit, reset, watch } = useForm<IRecRepFilter>({
        defaultValues: props.salEffFilter,
        shouldFocusError: false
    });

    const searchToDB = async (body: IRecRepFilter) => {
        let filterData: any = body;
        let emptyFilter: any = EmptyRecRepFilter;
        for (let key in filterData) {
            if (filterData[key] === "-- SELECT --" || filterData[key] === 0) {
                filterData[key] = emptyFilter[key];
            }
        }
        body = filterData;
        props.setSalEffFilter(body);
    }

    const loadsubClientCompanies = async (filter: string | null) => {
        const response = await Fetch("Dropdown/sub_vendor_companies", "GET", null, `filter=${filter}`, null);
        if (response) {
            const data: Array<IClientCompanyDropdown> = await response.json();
            setsubVendorCompanies(data);
        }
    }

    const completeMethodSubVendor = (event: { query: string }) => {
        loadsubClientCompanies(event.query);
    }

    function onSubmit(data: IRecRepFilter) {
        if (data.subVendor?.vendor_Company_ID) data.subVendorID = data.subVendor?.vendor_Company_ID;
        delete data.subVendor;
        searchToDB(data);
        props.onsearch();
    }


    return (
        <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid">
            {/* <JVInput column={6} label="SubVendor Name" control={control} name="subvendor_Name" /> */}
            <JVDate maxDate={new Date} column={6} label="From Date" control={control} name="fromDate" />
            <JVDate maxDate={new Date} column={6} label="To Date" control={control} name="toDate" />
            <JVDropdownInput column={6} label="Sub Vendor" completeMethod={completeMethodSubVendor} control={control} name="subVendor" options={subVendorCompanies} optionLabel="vendor_Company_Name" placeholder="Search Sub Vendor" />

            {/* <div className="col-12 md:col-12" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', columnGap: '10px', marginTop: '10px' }}>
                <Button className="field col-12 md:col-6" label="SEARCH" type="submit"></Button>
                <Button className="field col-12 md:col-6 p-button-outlined" label="CLEAR" onClick={() => { reset(EmptyRecRepFilter); }} type="button"></Button>
            </div> */}
            <div className="p-field p-col-12 p-md-6 p-d-flex p-ai-end p-jc-between" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', columnGap: '10px', marginTop: '24px', marginLeft: '20px', marginBottom: '-1px', width: "20%" }}>
                <Button className="field col-12 md:col-6" label="SEARCH" type="submit"></Button>
                <Button className="field col-12 md:col-6 p-button-outlined" label="CLEAR" onClick={() => { reset(EmptyRecRepFilter); }} type="button"></Button>
            </div>

        </form>
    );
}
